import type { SelfReportFreeFormColumnInstancesResponse } from '@/features/operation-packages/api';
import type { SelfReportInstanceRow, SelfReportQuestionColumn } from './type';
type ApiInstanceRow = SelfReportFreeFormColumnInstancesResponse['items'][number];
type ApiQuestionColumn = SelfReportFreeFormColumnInstancesResponse['questionColumns'][number];

/** with-free-form-columns の questionColumns を UI 用に変換する */
export function mapSelfReportQuestionColumns(questionColumns: ApiQuestionColumn[]): SelfReportQuestionColumn[] {
  return questionColumns.map(column => ({
    questionDefinitionId: column.questionDefinitionId,
    name: column.name
  }));
}

/** with-free-form-columns の 1 行をセルフレポート進捗行へ変換する */
export function mapSelfReportInstanceToRow(row: ApiInstanceRow): SelfReportInstanceRow {
  return {
    id: row.id,
    completedOperationStepCount: row.completedOperationStepCount,
    totalOperationStepCount: row.totalOperationStepCount,
    target: {
      targetType: row.target.targetType,
      targetId: row.target.targetId,
      targetName: row.target.targetName,
      targetAvatarUrl: row.target.targetAvatarUrl
    },
    anchorDate: row.anchorDate,
    tag: row.tag ?? null,
    columns: row.columns.map(column => ({
      questionDefinitionId: column.questionDefinitionId,
      answerStatus: column.answerStatus
    }))
  };
}